import { useContext, useEffect, useState } from 'react';
import { NavigationContext } from '@react-navigation/native';
/**
 * Whether this screen is the one on top of its stack, for views that follow the keyboard.
 *
 * The keyboard height is shared by every screen, so a screen still visible behind another
 * one (during a push, or a back swipe to it) followed the other screen's keyboard. This turns
 * false only once another screen has finished covering this one, and true again when this
 * screen is focused, which during a back swipe is once the swipe has completed. Outside a
 * navigator it is always true.
 */
export const useIsTopScreen = () => {
    const navigation = useContext(NavigationContext);
    const [isTopScreen, setIsTopScreen] = useState(() => navigation?.isFocused() ?? true);
    useEffect(() => {
        if (!navigation)
            return undefined;
        const unsubscribeFocus = navigation.addListener('focus', () => setIsTopScreen(true));
        // Emitted by native-stack only; other navigators never cover a screen this way.
        const unsubscribeTransitionEnd = navigation.addListener('transitionEnd', (event) => {
            if (event.data?.closing)
                setIsTopScreen(false);
        });
        return () => {
            unsubscribeFocus();
            unsubscribeTransitionEnd();
        };
    }, [navigation]);
    return isTopScreen;
};
